import axios from "axios";
import { getToken } from "./auth";

const API_URL = process.env.REACT_APP_API_S3HANDLER_URL;
const apiS3Handler = axios.create({
  baseURL: API_URL,
  responseType: "json",
});

apiS3Handler.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default apiS3Handler;
